/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_ManageInputs */

const en_directory_submit_enrich_manage = /** @type {(inputs: Directory_Submit_Enrich_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View in My Tools`)
};

const zh_directory_submit_enrich_manage = /** @type {(inputs: Directory_Submit_Enrich_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在“我的工具”中查看`)
};

/**
* | output |
* | --- |
* | "View in My Tools" |
*
* @param {Directory_Submit_Enrich_ManageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_manage = /** @type {((inputs?: Directory_Submit_Enrich_ManageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_ManageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_manage(inputs)
	return zh_directory_submit_enrich_manage(inputs)
});
export { directory_submit_enrich_manage as "directory.submit.enrich.manage" }